import * as Yup from 'yup';

export default Yup
  .string()
  .trim()
  .matches(/^[^\d ]+ [^\d ][^\d]+$/, 'Nome e sobrenome não são válidos')
  .required('Este campo é obrigatório');
